import { Pipe, PipeTransform } from '@angular/core';

import { SubMenuItem } from '../models/menu.item';

@Pipe({
  name: 'includesActiveInLinks',
  standalone: true,
})
export class IncludesActiveInLinksPipe implements PipeTransform {
  transform(
    value: SubMenuItem[] | SubMenuItem | undefined,
    currentPath: string,
  ): boolean {
    if (!value) {
      return false;
    }

    if (!Array.isArray(value)) {
      return this.isActive(value, currentPath);
    }

    return value.some((item) => this.isActive(item, currentPath));
  }

  isActive(item: SubMenuItem, currentPath: string): boolean {
    if (!item.path) {
      return false;
    }
    if (item.path === '/') {
      return item.path === currentPath;
    }

    return currentPath.startsWith(item.path);
  }
}
